import { configureStore } from "@reduxjs/toolkit";
import { thunk } from "redux-thunk"; // Use named import
import { combineReducers } from "redux";
import blogReducer from "./reducers/blogReducer";
import authReducer from './authSlice';
import userReducer from "./reducers/userReducer";

const rootReducer = combineReducers({
  // auth: authReducer,
  user: userReducer,
  blog: blogReducer,
  
  // Add other reducers here
});

// Configure Redux store with Thunk middleware
const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(thunk), // ✅ Works now
});

// Export RootState type
export type RootState = ReturnType<typeof store.getState>;
// Export AppDispatch for use in components
export type AppDispatch = typeof store.dispatch;

export default store;




